import { type MaybeComputedElementRef, unrefElement } from '@vueuse/core';

export const useInsertAtCursorPosition = (textareaRef: MaybeComputedElementRef) => {
  const insertAtCursorPosition = (value: string) => {
    const textarea = unrefElement(textareaRef)?.querySelector('textarea');
    if (!textarea) return;

    const insertText = value;
    const sentence = textarea.value;
    const len = sentence.length;

    const posStart = textarea.selectionStart !== undefined ? textarea.selectionStart : 0;
    const hasSelection = textarea.selectionStart !== textarea.selectionEnd;

    const before = sentence.substring(0, posStart);
    let newText: string;

    let newCursorPosition: number;

    if (!hasSelection) {
      const after = sentence.substring(posStart, len);
      const spacePrefix = before.length > 0 ? ' ' : '';
      const spaceSuffix = after.length > 0 ? ' ' : '';

      newText = before + spacePrefix + insertText + spaceSuffix + after;
      newCursorPosition = posStart + value.length + spacePrefix.length + spaceSuffix.length;
    } else {
      const posEnd = textarea.selectionEnd;
      const afterSelection = sentence.substring(posEnd);

      newText = before + insertText + afterSelection;
      newCursorPosition = posStart + value.length;
    }

    textarea.value = newText;
    textarea.focus();

    textarea.setSelectionRange(newCursorPosition, newCursorPosition);
  };

  return { insertAtCursorPosition };
};
